import { LicenseType } from 'app/constants/licenseType'

export const getLicenseTypeName = (
  licenseType: LicenseType,
  translate: (string) => string,
): string => {
  const text: string =
    LicenseType[licenseType == LicenseType.STDPlus ? 'STDPlus' : licenseType]
  return translate(`licenseType.${text}`)
}
